<template>
    <div class="row mb-4 sleep-section">
        <div class="col-12 pl-4 ">
            <div class="card border-0 ">
                <div class="card-body bg-white border-radius-5 p-4">
                    <div class="row no-gutters sleep-cycle mb-3">
                        <div class="col-lg-12 mb-3">
                            <h2 class="Schedule-heading mb-0">Phase of the sleep cycle</h2>
                        </div>
                        <div class="row no-gutters">
                            <div class="col-lg-6 pr-3">
                                <div class="p-4 bg-body Phase  ">
                                    <div class="sleep-data d-flex justify-content-between align-items-center">
                                        <div class="sleep-dataLeft">
                                            <h3>Sleep</h3>
                                            <h4>Avg. Time IN Bed</h4>
                                            <h3>6<span>hr</span> 32 <span>min</span></h3>
                                            <p>May 18-24, 2021</p>
                                        </div>
                                        <div class="sleep-dataright">
                                            <div class="sleep-rating">
                                                <p>Rating</p>
                                                <h3>80%</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-4 sleep-chart">
                                        <img src="../../../../static/website/images/Sleep-Data.png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 pl-3">
                                <div class="measurement-section d-flex justify-content-space-around  align-items-center">
                                    <div class="measurementsmain">
                                        <div class="measurementArea">
                                            <div>
                                                <h4>6</h4>
                                                <p>Days</p>
                                            </div>
                                        </div>
                                        <h3>Measurements</h3>
                                    </div>
                                    <div class="measurementsmain">
                                        <div class="measurementArea">
                                            <div>
                                                <h4>8</h4>
                                                <p>Days</p>
                                            </div>
                                        </div>
                                        <h3>Deep Sleep</h3>
                                    </div>
                                    <div class="measurementsmain">
                                        <div class="measurementArea">
                                            <div>
                                                <h4>6 <span>hr</span></h4>
                                                <h4> 36 <span>min</span></h4>
                                            </div>
                                        </div>
                                        <h3>REM Sleep</h3>
                                    </div>
                                    <div class="measurementsmain">
                                        <div class="measurementArea">
                                            <div>
                                                <h4>No</h4>
                                                <p>Average</p>
                                            </div>
                                        </div>
                                        <h3>Awake Time</h3>
                                    </div>
                                </div>
                                <div class="Schedule-section mt-5">
                                    <h2 class="mb-3 Schedule-heading">Your Schedule</h2>
                                    <div class="Schedule-section py-4 px-3 bg-body border-radius-8 w-75">
                                        <div class="edit-Schedule d-flex justify-content-between mb-3">
                                            <a href="#" class="next">Next</a>
                                            <a href="#" class="edit">Edit</a>
                                        </div>
                                        <div class="BedTime d-flex justify-content-between">
                                            <div class="BedTimeLeft">
                                                <h3><img src="../../../../static/website/images/bed-schedule.svg" alt="" class="icon"> Bed Time</h3>
                                                <h4>11:00 PM</h4>
                                                <p>Today</p>
                                            </div>
                                            <div class="BedTimeright">
                                                <h3><i class="icon icon-bell"></i> Bed Time</h3>
                                                <h4>11:00 PM</h4>
                                                <p>Today</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row no-gutters mt-5 sunrise-section">
                        <div class="col-lg-12 ">
                            <h2 class="Schedule-heading mb-0">Get More From Health</h2>
                        </div>
                        <div class="row no-gutters mt-3 w-100">
                            <div class="col-lg-4 pr-3">
                                <div class="bg-body border-radius-5 p-4 w-100">
                                    <div class="sunrise ">
                                        <img src="../../../../static/website/images/sunrise.svg" alt="" class="icon">
                                    </div>
                                    <h3>Set Up Wind Down Shortcuts</h3>
                                    <p>It is a long established fact that a reader will be distracted by the readable
                                        content of a
                                        page when looking at its layout.</p>
                                    <a href="#" class="btn btn-blue started w-100">Get Started</a>
                                </div>
                            </div>
                            <div class="col-lg-4 pr-3">
                                <div class="bg-body border-radius-5 p-4 w-100">
                                    <div class="sunrise ">
                                        <img src="../../../../static/website/images/sunrise.svg" alt="" class="icon">
                                    </div>
                                    <h3>Set Up Wind Down Shortcuts</h3>
                                    <p>It is a long established fact that a reader will be distracted by the readable
                                        content of a
                                        page when looking at its layout.</p>
                                    <a href="#" class="btn btn-blue started w-100">Get Started</a>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="bg-body border-radius-5 p-4 w-100">
                                    <div class="sunrise ">
                                        <img src="../../../../static/website/images/sunrise.svg" alt="" class="icon">
                                    </div>
                                    <h3>Set Up Wind Down Shortcuts</h3>
                                    <p>It is a long established fact that a reader will be distracted by the readable
                                        content of a
                                        page when looking at its layout.</p>
                                    <a href="#" class="btn btn-blue started w-100">Get Started</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row no-gutters mt-5 about-sleep-section">
                        <div class="col-lg-12 ">
                            <h2 class="Schedule-heading mb-0">About Sleep</h2>
                        </div>
                        <div class="row no-gutters mt-3 w-100">
                            <div class="col-lg-12">
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
                                    has been
                                    the industry's standard dummy text ever since the 1500s, when an unknown printer took a
                                    galley
                                    of type and scrambled it to make a type specimen book. It has survived not only five
                                    centuries,
                                    but also the leap into electronic typesetting, remaining essentially unchanged. It was
                                    popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum
                                    passages,
                                    and more recently with desktop publishing software like Aldus PageMaker including
                                    versions of
                                    Lorem Ipsum.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row no-gutters mt-5 Recorded-section">
                        <div class="col-lg-12 d-flex justify-content-between align-items-center ">
                            <h2 class="Schedule-heading mb-0">All Recorded Data</h2>
                            <ul class="mb-0 d-flex Record-list">
                                <li><a href="#" class="active">All</a></li>
                                <li><a href="#">Week</a></li>
                                <li><a href="#">Month</a></li>
                                <li><a href="#">Year</a></li>
                            </ul>
                        </div>
                        <div class="row no-gutters mt-3 w-100">
                            <div class="col-lg-12">
                                <div class="table-responsive Diebetes-list-section">
                                    <table class="table Medicine-list mb-0 border-0" border="0" cellspacing="0"
                                        cellpadding="0">
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Measurements</th>
                                                <th>Sleep Goal</th>
                                                <th>Average Time in Bed</th>
                                                <th>Average Time in Bed</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>24 April 2021</td>
                                                <td>7 days</td>
                                                <td>8 hr</td>
                                                <td>6hr 45min</td>
                                                <td>6hr 45min</td>
                                            </tr>
                                            <tr>
                                                <td>24 April 2021</td>
                                                <td>7 days</td>
                                                <td>8 hr</td>
                                                <td>6hr 45min</td>
                                                <td>6hr 45min</td>
                                            </tr>
                                            <tr>
                                                <td>24 April 2021</td>
                                                <td>7 days</td>
                                                <td>8 hr</td>
                                                <td>6hr 45min</td>
                                                <td>6hr 45min</td>
                                            </tr>
                                            <tr>
                                                <td>24 April 2021</td>
                                                <td>7 days</td>
                                                <td>8 hr</td>
                                                <td>6hr 45min</td>
                                                <td>6hr 45min</td>
                                            </tr>
                                            <tr>
                                                <td>24 April 2021</td>
                                                <td>7 days</td>
                                                <td>8 hr</td>
                                                <td>6hr 45min</td>
                                                <td>6hr 45min</td>
                                            </tr>
                                            <tr>
                                                <td>24 April 2021</td>
                                                <td>7 days</td>
                                                <td>8 hr</td>
                                                <td>6hr 45min</td>
                                                <td>6hr 45min</td>
                                            </tr>
                                            <tr class="border-bottom">
                                                <td>24 April 2021</td>
                                                <td>7 days</td>
                                                <td>8 hr</td>
                                                <td>6hr 45min</td>
                                                <td>6hr 45min</td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                                <nav aria-label="Page navigation ">
                                    <ul class="pagination justify-content-end my-3">
                                        <li class="page-item"><a class="page-link" href="#">Previous</a></li>
                                        <li class="page-item"><a class="page-link" href="#">1</a></li>
                                        <li class="page-item"><a class="page-link" href="#">2</a></li>
                                        <li class="page-item"><a class="page-link" href="#">3</a></li>
                                        <li class="page-item"><a class="page-link" href="#">...</a></li>
                                        <li class="page-item"><a class="page-link" href="#">Next</a></li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
	export default {
        name: 'sleep',

    }
</script>


// WEBPACK FOOTER //
// src/components/website/health_tracker/sleep.vue